


































































































































































































































































































































































































































































































import Vue from 'vue';
import moment from 'moment';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import DropdownOption from '@/models/misc/DropdownOption';
import { TransitTime } from '@/models/admin/TransitTime';

import localStorageService from '@/services/LocalStorageService';
import countryService from '@/services/CountryService';
import locationsService from '@/services/LocationsService';
import mapsService from '@/services/MapsService';
import carrierLogoService from '@/services/CarrierLogoService';
import transitTimeService from '@/services/TransitTimeService';
import holidayService from '@/services/HolidayService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      loading: false,
      mapSrc: null,
      showMap: false,
      countriesDll: [] as DropdownOption[],
      origStatesDdl: [] as DropdownOption[],
      destStatesDdl: [] as DropdownOption[],
      selectedOrigCountry: null as DropdownOption,
      selectedOrigState: null as DropdownOption,
      origCity: null,
      origPostalCode: null,
      selectedDestCountry: null as DropdownOption,
      selectedDestState: null as DropdownOption,
      destCity: null,
      destPostalCode: null,
      pickupDate: null,
      transitTimes: [] as TransitTime[],
      page: [] as TransitTime[],
      isPristine: true,
      holidays: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    backToPrevPage() {
      history.back();
    },
    init() {
      this.countriesDll = countryService.getAll();
      this.origCountryChanged({ value: 'USA' });
      this.destCountryChanged({ value: 'USA' });

      this.pickupDate = moment().format('YYYY-MM-DD');

      holidayService.getAll().then((x) => {
        this.holidays = x.map((p) =>
          moment((p as any).date).format('YYYY-MM-DD')
        );
      });
    },
    allowedDates(val) {
      var momentTime = moment(val);
      var today = moment();

      if (momentTime.isBefore(today, 'day')) {
        // Date is in the past
        return false;
      }

      if (momentTime.isoWeekday() === 6 || momentTime.isoWeekday() === 7) {
        return false;
      }

      return !this.holidays.includes(val);
    },
    formatDate(date) {
      return moment(date).format('MM/DD/YYYY');
    },
    calcDeliveryDate(transitDays) {
      var pickupMoment = moment(this.pickupDate);

      var deliveryMoment = pickupMoment.add(transitDays, 'days');

      if (deliveryMoment.isoWeekday() === 6) {
        // Saturday
        deliveryMoment.add(2, 'days');
      } else if (deliveryMoment.isoWeekday() === 7) {
        // Sunday
        deliveryMoment.add(1, 'day');
      }

      return deliveryMoment.format('MM/DD/YYYY');
    },
    origCountryChanged(selected) {
      if (selected) {
        locationsService.getListOfStates(selected.value).then((x) => {
          this.origStatesDdl = x.map(this.mapStates);
        });
      }
    },
    destCountryChanged(selected) {
      if (selected) {
        locationsService.getListOfStates(selected.value).then((x) => {
          this.destStatesDdl = x.map(this.mapStates);
        });
      }
    },
    mapStates(state) {
      return new DropdownOption(state.name, state.id);
    },
    search() {
      if (!this.origPostalCode || !this.destPostalCode) return;

      this.loading = true;
      mapsService
        .getImagePathAsync(
          this.origPostalCode,
          this.destPostalCode,
          [],
          this.displayEmail
        )
        .then((x) => {
          this.mapSrc = x;
        });

      transitTimeService
        .search(this.origPostalCode, this.destPostalCode, this.pickupDate)
        .then((x: TransitTime[]) => {
          this.transitTimes = x;
          this.pageChange(1);
        })
        .finally(() => {
          this.loading = false;
        });

      fetch(this.mapSrc).then((data) => {
        this.showMap = data.status == 404 ? false : true;
      });
    },
    path(carrierName: string) {
      const logo = carrierLogoService.getLogoPath(carrierName);

      /* istanbul ignore next */
      return logo != null ? logo.src : '';
    },
    clearFilters() {
      this.currentPage = 1;
      this.mapSrc = null;
      this.showMap = false;
      this.selectedOrigCountry = null;
      this.selectedOrigState = null;
      this.origCity = null;
      this.origPostalCode = null;
      this.selectedDestCountry = null;
      this.selectedDestState = null;
      this.destCity = null;
      this.destPostalCode = null;
      this.pickupDate = moment().format('YYYY-MM-DD');
      this.transitTimes = [];
      this.page = [];

      this.$refs.origPostalCode.reset();
      this.$refs.destPostalCode.reset();
    },
    terminalAddress(time, addressType) {
      if (
        !time[addressType + 'City'] &&
        !time[addressType + 'State'] &&
        !time[addressType + 'Address1'] &&
        !time[addressType + 'PostalCode'] &&
        !time[addressType + 'Phone']
      ) {
        return 'Not Available';
      }

      var addressArray = [];

      // Check if each address element is present, and add it to the array if so
      if (time[addressType + 'Address1']) {
        addressArray.push(time[addressType + 'Address1']);
      }
      if (time[addressType + 'City']) {
        addressArray.push(time[addressType + 'City']);
      }
      if (time[addressType + 'State']) {
        addressArray.push(time[addressType + 'State']);
      }
      if (time[addressType + 'PostalCode']) {
        addressArray.push(time[addressType + 'PostalCode']);
      }
      if (time[addressType + 'Phone']) {
        addressArray.push(
          'Phone: ' + this.formatPhone(time[addressType + 'Phone'])
        );
      }

      // Join the address elements with commas and return the resulting string
      return addressArray.join(', ');
    },
    pageChange(newPage) {
      let page = this.transitTimes.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
      this.page = page;
    },
  },
  computed: {
    pageHeader() {
      return `${this.client?.company}’s Transit-Time-Search`;
    },
    client() {
      return localStorageService.get('selected-afs-client');
    },
    transitTimesLoaded() {
      return this.transitTimes.length > 0;
    },
    pagingLength() {
      return Math.ceil(this.transitTimes.length / this.pageSize);
    },
    isPristineComputed() {
      return this.isPristine;
    },
    backToLbl() {
      return document.referrer?.includes('/dashboard')
        ? 'Back to Dashboard'
        : 'Back to Clients';
    },
  },
});
